module.exports = "<div id=\"main-content-wrapper\" class=\"content-wrapper\">\n  <router-outlet></router-outlet>\n</div>"